const ROUTER_CONSTANT = {
  ROOT: {
    ROOT: "",
    HOME: "/home",
    LOGIN: "/login",
    WAITLIST: "/waitlist",
    NOTIFICATION: "/notification",
    CHAT: "/chat",
    ALL_MENU: "/allMenu",
    COMPLAINT: "/complaint",
    FUNCTION: "/function",
    FUNCTION_DETAIL: "/functionDetail",
    GALLARY: "/gallary",
    NOTICE_BOARD: "/noticeBoard",
    POLLING: "/polling",
    ELECTION: "/election",
    ELECTION_DETAIL: "/electionDetail",
    SOCIETY_DOX: "/societyDox",
    VISITOR: "/visitor",
    MEMBER: "/member",
    USER_QR: "/userQR",
    ADDRESS: "/address",
    ONBOARDING: "/onboarding",
  },
  PROFILE: {
    ROOT: "/profile",
    STATEMENT: "/statement",
    MY_STATEMENT: "/mystatement",
    SOCIETY_STATEMENT: "/sstatement",
    ADD_ASSET: "/addAsset",
    EDIT: "/editProfile",
  },
  SOCIETY: {
    MEMBER: "/member",
    SOCIETY_DETAIL: "/societyDetails",
    ADD_FUNCTION: "/addFunction",
    ADMIN: "/manage-society",
    USER_PROFILE: "/profile",
    MEMBER_REQUEST: "/member-request",
    SETTINGS: "/society-settings",
    SUBSCRIPTION: "/subscription",
    ANALYTICS: "/analytics",
  },
  AGENT: {
    ROOT: "/agent",
    SUBSCRIPTIONS: "/agent/subscriptions",
  },
  GUARD: {
    MANAGE: "/manage-guard",
    ROOT: "/guard",
    SCAN: "/scan",
    SOS_HISTORY: "/sos-history"
  },
  APPROVAL: {
    ROOT: "/approval",
  },
  MAINTENANCE: {
    USER: "/maintenance",
    ADMIN: "/maintenance/admin",
    ADMIN_VERIFICATIONS: "/maintenance/admin/verifications",
    ADMIN_STATEMENT_CHECKER: "/maintenance/admin/statement-checker",
    ADMIN_STATEMENT_UPLOAD: "/maintenance/admin/statement-upload",
    ADMIN_STATEMENT_HISTORY: "/maintenance/admin/statement-history"
  },
  VEHICLES: "/vehicles",
  FUND: {
    ADMIN: "/fund",
    USER: "/fund/view"
  },
  DIRECTORY: {
    ROOT: '/directory',
    NEIGHBOURS: '/directory/neighbours',
    VEHICLES: '/directory/vehicles',
    PETS: '/directory/pets',
    GUARDS: '/directory/guards',
    COMMITTEE: '/directory/committee',
    DAILY_HELP: '/directory/daily-help',
    DAILY_HELP_CATEGORY_ROOT: '/directory/daily-help/category',
    DAILY_HELP_CATEGORY: (category: string) => `/directory/daily-help/category/${encodeURIComponent(category)}`,
    DAILY_HELP_PROFILE: (id: number) => `/directory/daily-help/${id}`,
    DAILY_HELP_MY_FLATS: '/directory/daily-help/my-flats',
  },
  AMENITIES: {
    ROOT: '/amenities',
    DETAIL: '/amenities/:id',
    MY_BOOKINGS: '/amenities/bookings/mine',
    REQUESTS: '/amenities/requests',
    ADMIN: '/admin/amenities',
  },
};

export const ROUTER_PARAMS = {
  ASSET_TYPE: 'assetType',
  FUNCTION_ID: "funId",
  AMENITY_ID: 'id',
  DAILY_HELP_CATEGORY: 'category',
  DAILY_HELP_ID: 'id',
}

export default ROUTER_CONSTANT;
